module.exports = __webpack_public_path__ + "static/img/accommodation-convenience-icon02.3735505f.svg";